module.exports = __webpack_public_path__ + "img/img14.93dd58b1.png";